Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=require("lodash/isEqual");var _isEqual3=_interopRequireDefault(_isEqual2);var _keys2=require("lodash/keys");var _keys3=_interopRequireDefault(_keys2);var _groupBy2=require("lodash/groupBy");var _groupBy3=_interopRequireDefault(_groupBy2);var _isFunction2=require("lodash/isFunction");var _isFunction3=_interopRequireDefault(_isFunction2);var _throttle2=require("lodash/throttle");var _throttle3=_interopRequireDefault(_throttle2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _victoryCore=require("victory-core");

var _d3Voronoi=require("d3-voronoi");
var _react=require("react");var _react2=_interopRequireDefault(_react);
var _eventHandlers=require("../../helpers/event-handlers.js");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}

var VoronoiHelpers={
withinBounds:function withinBounds(props,point){var
width=props.width,height=props.height,voronoiPadding=props.voronoiPadding;
var padding=voronoiPadding||0;var
x=point.x,y=point.y;
return x>=padding&&x<=width-padding&&y>=padding&&y<=height-padding;
},

getDatasets:function getDatasets(props){
var addMeta=function addMeta(data,name,child){
var continuous=child&&child.type&&child.type.continuous;
var style=child?child.props&&child.props.style:props.style;
return data.map(function(datum,index){
var x=datum._x1!==undefined?datum._x1:datum._x;
var y=datum._y1!==undefined?datum._y1:datum._y;
return(0,_assign3.default)({
_voronoiX:props.dimension==="y"?0:x,
_voronoiY:props.dimension==="x"?0:y,
childName:name,eventKey:index,continuous:continuous,style:style},
datum);
});
};

if(props.data){
return addMeta(props.data);
}

var getData=function getData(childProps){
var data=_victoryCore.Data.getData(childProps);
return Array.isArray(data)&&data.length>0?data:undefined;
};

var iteratee=function iteratee(child,childName,parent){
if(child.type&&child.type.role==="axis"){
return null;
}else if(child.type&&(0,_isFunction3.default)(child.type.getData)){
child=parent?_react2.default.cloneElement(child,parent.props):child;
var childData=child.props&&child.type.getData(child.props);
return childData?addMeta(childData,childName,child):null;
}else{
var _childData=getData(child.props);
return _childData?addMeta(_childData,childName,child):null;
}
};
return _victoryCore.Helpers.reduceChildren(_react2.default.Children.toArray(props.children),iteratee);
},



mergeDatasets:function mergeDatasets(props,datasets){var
scale=props.scale;
var points=(0,_groupBy3.default)(datasets,function(datum){
var x=scale.x(datum._voronoiX);
var y=scale.y(datum._voronoiY);
return x+","+y;
});
return(0,_keys3.default)(points).map(function(key){
var point=key.split(",");
return{
x:+point[0],
y:+point[1],
points:points[key]};

});
},

getVoronoi:function getVoronoi(props,mousePosition){var
width=props.width,height=props.height,voronoiPadding=props.voronoiPadding;
var padding=voronoiPadding||0;
var voronoiFunction=(0,_d3Voronoi.voronoi)().
x(function(d){return d.x;}).
y(function(d){return d.y;}).
extent([[padding,padding],[width-padding,height-padding]]);
var datasets=this.getDatasets(props);
var voronoi=voronoiFunction(this.mergeDatasets(props,datasets));
var size=props.dimension?undefined:props.radius;
return voronoi.find(mousePosition.x,mousePosition.y,size);
},

getActiveMutations:function getActiveMutations(props,point){var
childName=point.childName,continuous=point.continuous;
var targets=props.labels?["data"]:["data","labels"];
return targets.map(function(target){
var eventKey=continuous===true&&target==="data"?"all":point.eventKey;
return{
childName:childName,eventKey:eventKey,target:target,mutation:function mutation(){return{active:true};}};

});
},

getInactiveMutations:function getInactiveMutations(props,point){var
childName=point.childName,continuous=point.continuous;
var targets=props.labels?["data"]:["data","labels"];
return targets.map(function(target){
var eventKey=continuous&&target==="data"?"all":point.eventKey;
return{
childName:childName,eventKey:eventKey,target:target,mutation:function mutation(){return null;}};

});
},

getParentMutation:function getParentMutation(activePoints,mousePosition){
return[{
target:"parent",
eventKey:"parent",
mutation:function mutation(){return{activePoints:activePoints,mousePosition:mousePosition};}}];

},

onActivated:function onActivated(props,points){
if((0,_isFunction3.default)(props.onActivated)){
props.onActivated(points);
}
},

onDeactivated:function onDeactivated(props,points){
if((0,_isFunction3.default)(props.onDeactivated)){
props.onDeactivated(points);
}
},

onMouseLeave:function onMouseLeave(evt,targetProps){var _this=this,_getParentMutation;
var activePoints=targetProps.activePoints||[];
this.onDeactivated(targetProps,activePoints);
var inactiveMutations=activePoints.length?
activePoints.map(function(point){return _this.getInactiveMutations(targetProps,point);}):[];
return(_getParentMutation=this.getParentMutation([])).concat.apply(_getParentMutation,_toConsumableArray(inactiveMutations));
},

onMouseMove:function onMouseMove(evt,targetProps){var _this2=this;
var activePoints=targetProps.activePoints||[];
var mousePosition=_victoryCore.Selection.getSVGEventCoordinates(evt);
if(!this.withinBounds(targetProps,mousePosition)){var _getParentMutation2;
this.onDeactivated(targetProps,activePoints);
var inactiveMutations=activePoints.length?
activePoints.map(function(point){return _this2.getInactiveMutations(targetProps,point);}):[];
return(_getParentMutation2=this.getParentMutation([],mousePosition)).concat.apply(_getParentMutation2,_toConsumableArray(inactiveMutations));
}
var nearestVoronoi=this.getVoronoi(targetProps,mousePosition);
var points=nearestVoronoi?nearestVoronoi.data.points:[];
var parentMutations=this.getParentMutation(points,mousePosition);
if(activePoints.length&&(0,_isEqual3.default)(points,activePoints)){
return parentMutations;
}else{
this.onActivated(targetProps,points);
this.onDeactivated(targetProps,activePoints);
var activeMutations=points.length?
points.map(function(point){return _this2.getActiveMutations(targetProps,point);}):[];
var _inactiveMutations=activePoints.length?
activePoints.map(function(point){return _this2.getInactiveMutations(targetProps,point);}):[];
return parentMutations.concat.apply(parentMutations,_toConsumableArray(_inactiveMutations).concat(_toConsumableArray(activeMutations)));
}
}};exports.default=


{
onMouseLeave:VoronoiHelpers.onMouseLeave.bind(VoronoiHelpers),
onMouseMove:(0,_throttle3.default)(
(0,_eventHandlers.attachId)(VoronoiHelpers.onMouseMove.bind(VoronoiHelpers)),
32,
{leading:true,trailing:false})};


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/containers/voronoi-helpers.js
// module id = 614
// module chunks = 0